<template>
  <div class="contacts">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 flex-top-block mt30">
          <div class="col-md-6 col-xs-12 col-sm-12">
            <h4 class="mx0 my10 title-location center-md center-xs">{{ $t('Customer support') }}</h4>
            <div class="flex-for-form">
              <div class="location-block col-md-12 col-xs-12 col-sm-12 location-block-location" v-for="(partnerInfo, index) in locationsInfo" :key="index">
                <div class="flex-top-block phone-and-email mx0 my10">
                  <div class="flex flex-col phone col-md-5" v-if="partnerInfo.support_phone_1 || partnerInfo.support_phone_2 || partnerInfo.support_phone_3">
                    <div class="flex location mx0">
                      <span class="material-icons">location_on</span> {{ $t(partnerInfo.name) }}
                    </div>
                    <p class="mx0 my10 time-work-location" v-if="partnerInfo.time_from && partnerInfo.time_to">
                      {{ $t('Mon - Sun') }} - <span>{{ partnerInfo.time_from.substring(0, 5) }}</span> - <span>{{ partnerInfo.time_to.substring(0, 5) }}</span>
                    </p>
                    <div class="flex phone-content">
                      <span class="material-icons phone-icon">phone</span>
                      <div class="mb10" v-if="partnerInfo.support_phone_1">
                        <a :href="'tel:' + partnerInfo.support_phone_1"
                           v-mask="{
                              mask: '+38(999)-999-9999',
                              showMaskOnHover: false,
                              autoUnmask: true
                            }"
                            class="info-location">
                          {{ formatPhone(partnerInfo.support_phone_1) }}
                        </a>
                      </div>
                      <div class="mb10" v-if="partnerInfo.support_phone_2">
                        <a :href="'tel:' + partnerInfo.support_phone_2"
                           v-mask="{
                              mask: '+38(999)-999-9999',
                              showMaskOnHover: false,
                              autoUnmask: true
                            }"
                           class="info-location">
                          {{ formatPhone(partnerInfo.support_phone_2) }}
                        </a>
                      </div>
                      <a v-if="partnerInfo.support_phone_3" :ref="'tel:' + partnerInfo.support_phone_3"
                         :href="'tel:' + partnerInfo.support_phone_3"
                         v-mask="{
                              mask: '+38(999)-999-9999',
                              showMaskOnHover: false,
                              autoUnmask: true
                            }"
                         class="info-location" >
                        {{ formatPhone(partnerInfo.support_phone_3) }}
                      </a>
                    </div>
                  </div>
                  <div class="emails col-md-7">
                    <div v-if="partnerInfo.office_email">
                      <div class="flex email">
                        <span class="material-icons">alternate_email</span>
                        <a :href="'mailto:' + partnerInfo.office_email" class="info-location" >{{ partnerInfo.office_email }}</a>
                      </div>
                    </div>
                    <div v-if="partnerInfo.hr_email">
                      <div class="flex resume mb5">
                        <span class="material-icons">account_circle</span>
                        {{$t('Recruitment department:')}}
                      </div>
                      <a :href="'mailto:' + partnerInfo.hr_email " class="info-location-resume">{{ partnerInfo.hr_email }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-form col-md-6 col-xs-12 col-sm-12">
            <h4 class="mx0 my10 title-location center-md center-xs">{{$t('Write to us')}}</h4>
            <contact-select-location @changeLocation="setLocation" />
            <base-input
              class="col-xs-12 col-md-12 "
              type="text"
              name="first-name"
              :placeholder="$t('First name *')"
              v-model.trim="reviewForm.firstName"
              @blur="$v.reviewForm.firstName.$touch()"
              autocomplete="given-name"
              :validations="[
                {
                  condition: $v.reviewForm.firstName.$error && !$v.reviewForm.firstName.required,
                  text: $t('Field is required')
                },
                {
                  condition: !$v.reviewForm.firstName.minLength,
                  text: $t('Name must have at least 2 letters.')
                }
              ]"
            />
            <base-input
              class="col-xs-12 "
              type="email"
              name="email-address"
              :placeholder="$t('Email address *')"
              v-model="reviewForm.emailAddress"
              @blur="$v.reviewForm.emailAddress.$touch()"
              autocomplete="email"
              :validations="[
                {
                  condition: $v.reviewForm.emailAddress.$error && !$v.reviewForm.emailAddress.required,
                  text: $t('Field is required')
                },
                {
                  condition: !$v.reviewForm.emailAddress.email && $v.reviewForm.emailAddress.$error,
                  text: $t('Please provide valid e-mail address.')
                }
              ]"
            />
            <base-textarea-contacts
              rows="4"
              cols="10"
              class="col-xs-12 text-area"
              maxlength="10000"
              :placeholder="$t('Your message')"
              v-model="reviewForm.message"
              @blur="$v.reviewForm.message.$touch()"
              type="text"
              :validations="[
                {
                  condition: $v.reviewForm.message.$error && !$v.reviewForm.message.required,
                  text: $t('Field is required')
                }
              ]"
            />
            <mini-button-full
              @click.native="sendReview"
              class="button-send"
            >
              <span class="material-icons" style="transform: rotateZ(-48deg); font-size: 14px;" >send</span>
              {{ $t('Send') }}
            </mini-button-full>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import { PersonalDetails } from '@vue-storefront/core/modules/checkout/components/PersonalDetails'
import { email, minLength, required } from 'vuelidate/lib/validators';
import ContactSelectLocation from '../Locations/ContactSelectLocation';
import { mapActions, mapGetters } from 'vuex';
import BaseTextareaContacts from '../../../core/blocks/Form/BaseTextareaContacts';

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');
const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');

export default {
  name: 'Contacts',
  components: {
    BaseInput,
    ContactSelectLocation,
    BaseTextareaContacts,
    MiniButtonFull
  },
  data () {
    return {
      droppoints: [],
      error: '',
      extraFields: {},
      loading: false,
      phoneNumber: null,
      searchZipcode: null,
      selected: {id: null},
      shipping: this.$store.state.checkout.shippingDetails,
      validationResults: {
        personalDetails: { $invalid: true },
        shipping: { $invalid: true }
      },
      customer: this.$store.state.user.current,
      locationCode: '',
      reviewForm: {
        firstName: '',
        emailAddress: '',
        message: ''
      },
      source: 'contact_us'
    }
  },
  beforeMount() {
    this.parsePhone();
  },
  methods: {
    ...mapActions({
      addReview: 'review/add'
    }),
    setLocation (location) {
      this.locationCode = location;
    },
    formatFone (phone) {
      let phoneCode = '+38';
      if (phone) {
        if (phone.includes(phoneCode)) {
          return phone.replace(phoneCode, '')
        }
      }
      return null
    },
    sendReview () {
      if (this.$v.$invalid) {
        this.showErrors('Some of the form fields are not valid!')
      } else if (!this.locationCode) {
        this.showErrors('Please, select location')
      } else {
        this.addReview({
          customer_id: this.customer ? this.customer.id : 0,
          customer_name: this.reviewForm.firstName,
          customer_email: this.reviewForm.emailAddress,
          location_code: this.locationCode,
          source: this.source,
          text: this.reviewForm.message
        }).then(sent => {
          // Keep what the customer typed when the message was rejected.
          if (sent) this.resetForm();
        });
      }
    },
    parsePhone () {
      this.locationsInfo.map(infoParter => {
        if (this.formatFone(infoParter.support_phone_1) !== null){
          infoParter.support_phone_1 = this.formatFone(infoParter.support_phone_1)
        }
        if (this.formatFone(infoParter.support_phone_2) !== null){
          infoParter.support_phone_2 = this.formatFone(infoParter.support_phone_2)
        }
        if (this.formatFone(infoParter.support_phone_3) !== null){
          infoParter.support_phone_3 = this.formatFone(infoParter.support_phone_3)
        }
      })
    },
    resetForm () {
      for (let field in this.reviewForm) {
        this.reviewForm[field] = '';
        this.$v.$reset();
      }
    },
    showErrors (messageError) {
      for (let field in this.reviewForm) {
        this.$v.reviewForm[field].$touch();
      }
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(messageError),
        action1: { label: this.$t('OK') }
      })
    },
    formatPhone (number) {
      const digits = number.replace(/\D/g, '').trim();
      if (digits.length === 10 && digits.startsWith('0')) {
        return digits.replace(/^0(\d{3})(\d{3})(\d{4})$/, '+38($1)-$2-$3');
      }

      if (digits.length === 12 && digits.startsWith('38')) {
        return digits.replace(/^38(\d{3})(\d{3})(\d{4})$/, '+38($1)-$2-$3');
      }

      return number;
    }
  },
  mixins: [PersonalDetails],
  computed: {
    ...mapGetters({
      locationsInfo: 'locations/getLocations'
    })
  },
  validations: {
    reviewForm: {
      firstName: {
        required,
        minLength: minLength(2)
      },
      emailAddress: {
        required,
        email
      },
      message: {
        required
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .flex-col {
    flex-direction: column;
  }

  .col-md-6 {
    @media (max-width: 1200px) and (min-width: 769px) {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
  .flex-for-form{
    @media (max-width: 1200px) {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
    @media (max-width: 768px) {
      display: block;
    }
    .col-md-12{
      @media (max-width: 1200px) and (min-width: 769px) {
        flex-basis: 47%;
        max-width: 47%;
      }
    }
  }
  .contact-form{
    width: 550px;
    @media (max-width: 1200px) {
      width:100%;
    }
  }
  .location-block-location{
    @media (max-width: 1200px) {
      margin-right: 15px;
    }
    @media (max-width: 768px) {
      margin-right: 0;
    }
  }
  .flex-top-block{
    display: flex;
    @media (max-width: 1200px) {
      display: block;
    }
    .col-md-5{
      @media (max-width: 1200px) and (min-width: 769px) {
        flex-basis: 100%;
        max-width: 100%;
      }
    }
    .col-md-7{
      @media (max-width: 1200px) and (min-width: 769px) {
        flex-basis: 100%;
        max-width: 100%;
      }
    }
  }
  .location-block{
    border-radius: 10px;
    border: solid 1px #eae9e6;
    background-color: #eae9e6;
    padding: 20px 40px;
    margin-bottom: 10px;
    @media (max-width: 425px) {
      width: 100%;
      padding: 20px 10px;
    }
  }
  .button-send{
    margin: 35px auto;
    margin-top: 10px;
    width: 40%;
    @media (max-width: 1200px) {
      margin-bottom: 20px;
    }
  }
  .textarea-custom {
    width: 98%;
    height: 90px;
    resize: none;
    border-radius: 5px;
    border: solid 1px #bdbdbd;
    background-color: #ffffff;
    font-family: 'TTNorms Regular', sans-serif;
    padding: 5px;
    font-size: 16px;
    @media (max-width: 1200px) {
      width: 99%;
    }
    @media (max-width: 768px) {
      width: 98%;
    }
    @media (max-width: 500px) {
      width: 97%;
    }
    @media (max-width: 350px) {
      width: 96%;
    }
  }
    .title-location{
      font-family: 'TTNorms Regular', sans-serif;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.11px;
      color: #111111;
    }
    .time-work-location{
      font-family: 'TTNorms Regular', sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.09px;
      span{
        color: #11bb2e;
      }
    }
    .phone-and-email{
      font-family: 'TTNorms Regular', sans-serif;
      vertical-align: middle;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.07;
      letter-spacing: 0.09px;
      @media (max-width: 425px) {
        display: block;
      }
      .phone{
        padding-left: 0;

        &-content {
          flex-direction: column;
          padding-left: 16px;
          position: relative;
        }

        &-icon {
          position: absolute;
          left: 0;
          top: 0;
        }

        @media (max-width: 425px) {
          padding-bottom: 10px;
        }
      }
      .info-location{
        padding-left: 5px;
        color: #11bb2e;
      }
      .info-location-resume{
        padding-left: 20px;
        color: #11bb2e;
      }
      span{
        font-size: 14px;
      }
      .emails{
        padding-left: 0;
        .email{
          margin-bottom: 10px;
        }
        @media (max-width: 1200px) {
          margin-top: 10px;
        }
      }
      .resume{
        span{
          padding-right: 5px;
        }
      }
    }
    .location{
      font-family: 'TTNorms Regular', sans-serif;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.1px;
      span{
        padding-right: 5px;
        font-size: 14px;
      }
    }
    .header-contact{
      background-image: url(/assets/backgr-contact.png);
      text-align: center;
      padding: 10px;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0.15px;
      color: #ffffff;
      width: 100%;
    }
</style>

<style lang="scss">
.contacts {
  .text-area {
    textarea {
      box-sizing: border-box;
      width: 100%;
    }
  }
}
</style>
